import type { TFanficAuthor } from '@/features/fanfic-page/types/fanfic';

type CanAccessFanficPreviewParams = {
  authors: TFanficAuthor[];
  userId: number | string | null | undefined;
};

/**
 * Preview is limited to work authors.
 */
export const canAccessFanficPreview = ({
  authors,
  userId,
}: CanAccessFanficPreviewParams): boolean => {
  if (userId == null) {
    return false;
  }

  return (authors ?? []).some((author) => author.id === userId);
};
